export const optionsPerson = [
  { label: "Друг", gender: "male" },
  { label: "Кум", gender: "male" },
  { label: "Сусід", gender: "male" },
  { label: "Однокласник", gender: "male" },
  { label: "Одногрупник", gender: "male" },
  { label: "Брат", gender: "male" },
  { label: "Партнер", gender: "male" },
  { label: "Побратим", gender: "male" },
  { label: "Керівник", gender: "male" },
  { label: "Дідусь", gender: "male" },
  { label: "Коханий", gender: "male" },
  { label: "Тато", gender: "male" },
  { label: "Дядько", gender: "male" },
  { label: "Син", gender: "male" },
  { label: "Онук", gender: "male" },
  { label: "Племінник", gender: "male" },
  { label: "Похрестник", gender: "male" },
  { label: "Хрещений", gender: "male" },
  { label: "Клієнт", gender: "male" },

  { label: "Подруга", gender: "female" },
  { label: "Кума", gender: "female" },
  { label: "Сестра", gender: "female" },
  { label: "Однокласниця", gender: "female" },
  { label: "Одногрупниця", gender: "female" },
  { label: "Партнерка", gender: "female" },
  { label: "Клієнтка", gender: "female" },
  { label: "Керівниця", gender: "female" },
  { label: "Бабуся", gender: "female" },
  { label: "Кохана", gender: "female" },
  { label: "Мама", gender: "female" },
  { label: "Тітка", gender: "female" },
  { label: "Дочка", gender: "female" },
  { label: "Онучка", gender: "female" },
  { label: "Племінниця", gender: "female" },
  { label: "Похрестниця", gender: "female" },
  { label: "Хрещена", gender: "female" },
  
  { label: "Колега" },
];

export const ageOptions = Array.from({ length: 101 }, (_, i) => ({
  value: i,
  label: i === 1 ? "1 рік" : `${i} років`,
})).filter((opt) => opt.value > 0);

export const optionsGreetingSubject = [
  "День святого Миколая",
  "День народження",
  "Річниця",
  "День ангела",
  "Весілля",
  "Підвищення",
  "Покупка",
  // "Професійне свято",
  "Календарне свято",
  "Мемний день",
  "Згадка",
];

export const optionsHobbies = [
  "Автомобіль",
  "Квіти",
  "Садівництво",
  "Бізнес",
  "Кулінарія",
  "Вино",
  "Кіт",
  "Бокал пива",
  "Риболовля",
  "Книги",
  "Мольберт",
  "Пес",
  // "Подарунковий торт",
  "Мотоцикл",
  "Подорожі",
  "Гантелі",
  "Футбольний м'яч",
  "IT",
  "Колонки",
  "Офіс",
  "Фотоапарат",
  "Гроші",
  "Відео-ігри",
  "Інструменти",
  "Окуляри",
  "Гітара",
  "Вишивка",
  "Велосипед",
];

// export const cardStyleOptions = [
//   "Мультяшний",
//   "Акварель",
//   "Line-art",
//   "Аніме",
//   "Pop-art",
//   "Журнальний",
//   "Масляний",
//   "Комікс",
//   "Піксель",
//   "Вінтаж",
//   "Барбі",
//   "Мультяшний гламур",
//   "Картина в стилі модернізм",
//   "Музичний альбом 80-х",
//   "Листівка 80-х",
//   "Мультик про піратів",
//   "Малюнок олівцем",
//   "Кольорові олівці",
//   "Афіша бойовика",
//   "Кібер панк",
//   "GTA San Andreas",
//   "Афіша фентезі з атрибутами",
//   "Картина в стилі романтизм",
//   "Комедійний постер",
//   "Детективний постер",
//   "Афіша вестерну з атрибутами",
// ];
export const cardStyleOption = [
  { ua: "Акварель", en: "Watercolor" },
  { ua: "Мультяшний", en: "Cartoon" },
  { ua: "Line-art", en: "Line Art" },
  { ua: "Аніме", en: "Anime" },
  { ua: "Pop-art", en: "Pop Art" },
  { ua: "Журнальний", en: "Magazine" },
  { ua: "Масляний", en: "Oil Painting" },
  { ua: "Комікс", en: "Comic" },
  { ua: "Піксель", en: "Pixel Art" },
  { ua: "Вінтаж", en: "Vintage" },
  { ua: "Барбі", en: "Barbie" },
  { ua: "Мультяшний гламур", en: "Cartoon Glamour" },
  { ua: "Картина в стилі модернізм", en: "Modernism Painting" },
  { ua: "Музичний альбом 80-х", en: "80s Music Album" },
  { ua: "Листівка 80-х", en: "80s Postcard" },
  { ua: "Мультик про піратів", en: "Pirate Cartoon" },
  { ua: "Малюнок олівцем", en: "Pencil Drawing" },
  { ua: "Кольорові олівці", en: "Colored Pencils" },
  { ua: "Афіша бойовика", en: "Action Movie Poster" },
  { ua: "Кібер панк", en: "Cyberpunk" },
  { ua: "GTA San Andreas", en: "GTA San Andreas" },
  { ua: "Афіша фентезі з атрибутами", en: "Fantasy Poster with Attributes" },
  { ua: "Картина в стилі романтизм", en: "Romanticism Painting" },
  { ua: "Комедійний постер", en: "Comedy Poster" },
  { ua: "Детективний постер", en: "Detective Poster" },
  { ua: "Афіша вестерну з атрибутами", en: "Western Poster with Attributes" },
];

export const cardStyleOptionNewYear = [
 { ua: "Watercolor", en: "in watercolor style" },
{ ua: "Cartoon", en: "in a cartoon style" },
{ ua: "Pop-art", en: "in a pop-art style" },
{ ua: "Anime", en: "in an anime style" },
{ ua: "Oil painting", en: "in an oil painting style" },
{ ua: "Modernism", en: "in the style of a modernist painting" },
{ ua: "Comics", en: "in a comics book style" },
{ ua: "Pencil", en: "in the style of a pencil drawing" },
{ ua: "Colored pencils", en: "in the style of colored pencils" },
{ ua: "Retro", en: "in the style of an 80s postcard" },
{ ua: "Vintage", en: "in a vintage style" },
{ ua: "Line-art", en: "in line-art style" },
{ ua: "Pixel", en: "in a pixel style" },
{ ua: "Magazine", en: "in a magazine style" },

];


export const cardMoodOptions = [
  // "Відповідний до наступного фото",
  "Святковий",
  "Романтичний",
  "Щирий",
  "Офіційний",
  // "Дотепний",
  "Смішний",
  "Мотиваційний",
  // "Саркастичний",
  // "Абсурдний гумор",
];

export const optionsTraits = [
  "Дружелюбність",
  "Активність",
  "Цілеспрямованість",
  "Уважність",
  "Ніжність",
  "Спокій",
  "Підтримка",
  "Любов",
  "Взаємодопомога",
  "Радість",
  "Ввічливість",
  "Жартівливість",
  "Веселощі",
  "Розум",
  "Гармонія",
];
// export const optionsBackgrounds = [
//   "Святковий торт",
//   "Доларові купюри",
//   "Бокал вина",
//   "Букет із семи тюльпанів",
//   "Audi a7",
//   "Атрибути риболовлі",
//   "Бургер",
//   "Засніжена різдвяна ялинка",
//   "Книги",
//   "Гори Карпат",
//   "Пшеничне поле",
//   "Квітучий сад",
//   "Засніжені вершини",
//   "Гітара",
//   "Лавандове поле",
//   "Сакура",
//   "Хмарочоси Києва",
//   "Графіті",
//   "Нью-Йорк",
//   "Історична частина Львова",
//   "Футбольне поле",
//   "Гори, пальми та океан",
//   "Тропіки",
//   "Неон",
//   "Рожевий кабріолет",
//   "Офіс",
//   "Ноутбук",
//   "Зимовий захід сонця",
// ];
export const optionsBackgrounds = [
  { ua: "Святковий торт", en: "Festive Cake" },
  { ua: "Доларові купюри", en: "Dollar Bills" },
  { ua: "Бокал вина", en: "Glass of Wine" },
  { ua: "Букет із семи тюльпанів", en: "Bouquet of Seven Tulips" },
  { ua: "Audi a7", en: "Audi A7" },
  { ua: "Атрибути риболовлі", en: "Fishing Gear" },
  { ua: "Бургер", en: "Burger" },
  { ua: "Засніжена різдвяна ялинка", en: "Snowy Christmas Tree" },
  { ua: "Книги", en: "Books" },
  { ua: "Гори Карпат", en: "Carpathian Mountains" },
  { ua: "Пшеничне поле", en: "Wheat Field" },
  { ua: "Квітучий сад", en: "Blooming Garden" },
  { ua: "Засніжені вершини", en: "Snowy Peaks" },
  { ua: "Гітара", en: "Guitar" },
  { ua: "Лавандове поле", en: "Lavender Field" },
  { ua: "Сакура", en: "Sakura" },
  { ua: "Хмарочоси Києва", en: "Kyiv Skyscrapers" },
  { ua: "Графіті", en: "Graffiti" },
  { ua: "Нью-Йорк", en: "New York" },
  { ua: "Історична частина Львова", en: "Historic Part of Lviv" },
  { ua: "Футбольне поле", en: "Football Field" },
  { ua: "Гори, пальми та океан", en: "Mountains, Palms and Ocean" },
  { ua: "Тропіки", en: "Tropics" },
  { ua: "Неон", en: "Neon" },
  { ua: "Рожевий кабріолет", en: "Pink Convertible" },
  { ua: "Офіс", en: "Office" },
  { ua: "Ноутбук", en: "Laptop" },
  { ua: "Зимовий захід сонця", en: "Winter Sunset" },
];


